module.exports = __webpack_public_path__ + "img/frame (227).e7e6ca21.jpg";